import React, { useMemo } from 'react';
import { COLORS, ExpansionBody, ExpansionHeader, ToggleIcon } from '@fupa/fupa-uikit';
import { LinkOnComponent } from 'app/components/links/link';
import { useLocation } from 'react-router';
import DistrictList from 'app/components/region/DistrictList';
const ROW_HEIGHT = 42;
const RegionSelect = _ref => {
  let {
    region,
    selectedRegion,
    districts,
    loadDistricts
  } = _ref;
  const {
    state: locationState
  } = useLocation();
  const isRegionOpen = useMemo(() => region.slug === selectedRegion, [region.slug, selectedRegion]);
  const shownDistricts = useMemo(() => {
    if (!selectedRegion || !districts[selectedRegion]) {
      return undefined;
    }
    return districts[selectedRegion];
  }, [selectedRegion, districts]);
  const expandedHeight = useMemo(() => {
    if (!isRegionOpen || !shownDistricts) return 0;
    return (shownDistricts.items.length || 1) * ROW_HEIGHT;
  }, [shownDistricts, isRegionOpen]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkOnComponent, {
    enablehover: true,
    replace: true,
    to: {
      pathname: "/select/".concat(region.slug),
      state: locationState
    },
    onClick: () => loadDistricts(region.slug),
    "data-sentry-element": "LinkOnComponent",
    "data-sentry-source-file": "RegionSelect.tsx"
  }, /*#__PURE__*/React.createElement(ExpansionHeader, {
    "data-sentry-element": "ExpansionHeader",
    "data-sentry-source-file": "RegionSelect.tsx"
  }, /*#__PURE__*/React.createElement(ToggleIcon, {
    addmargin: "right",
    open: isRegionOpen,
    style: {
      color: COLORS.darkGrey
    },
    "data-sentry-element": "ToggleIcon",
    "data-sentry-source-file": "RegionSelect.tsx"
  }), region.name)), /*#__PURE__*/React.createElement(ExpansionBody, {
    bgColor: COLORS.lighterGrey // default
    ,
    height: expandedHeight,
    "data-sentry-element": "ExpansionBody",
    "data-sentry-source-file": "RegionSelect.tsx"
  }, shownDistricts && /*#__PURE__*/React.createElement(DistrictList, {
    districts: shownDistricts.items,
    isFetching: shownDistricts.isFetching,
    referrer: locationState === null || locationState === void 0 ? void 0 : locationState.referrer
  })));
};
export default RegionSelect;